import i18n from '@/utils/i18n';
import React, { useCallback, useState } from 'react';
import { Alert } from '@/experiences/sales-portal/domain/insights/blocs/types/alert';
import { AlertCardSurface } from '@/experiences/sales-portal/domain/insights/components/alert-card/alert-card-surface';
import { HiddenAlertsSectionProps } from '@/experiences/sales-portal/domain/insights/components/hidden-alerts-section';
import { Icons, Typography, XStack, YStack } from '@usepepper/sprout-kit-ui';
import { InsightsMobileHiddenAlertsPushView } from '@/experiences/sales-portal/domain/insights/components/insights-mobile-hidden-alerts-push-view';
import { Pressable } from 'react-native';
import { useAlertPress } from '@/experiences/sales-portal/domain/insights/blocs/hooks/use-alert-press';

export const InsightsMobileHiddenAlerts: React.FC<HiddenAlertsSectionProps> = ({
  alerts,
  clearing,
  onClearAll,
  onDelete,
  onRestore,
  supplierUUID,
}) => {
  const { onAccountDetailPress, onAlertPress } = useAlertPress(supplierUUID);
  const [open, setOpen] = useState(false);

  const handleAccountDetailPress = useCallback(
    (alert: Alert) => () => {
      setOpen(false);
      onAccountDetailPress(alert)();
    },
    [onAccountDetailPress],
  );

  const handleAlertPress = useCallback(
    (alert: Alert) => {
      const press = onAlertPress(alert);
      return press
        ? () => {
            setOpen(false);
            press();
          }
        : undefined;
    },
    [onAlertPress],
  );

  return (
    <>
      <Pressable
        accessibilityLabel={i18n.t('insights_hub.hidden_alerts.title')}
        accessibilityRole="button"
        onPress={() => setOpen(true)}
      >
        <YStack marginBottom="$16">
          <AlertCardSurface>
            <XStack
              alignItems="center"
              gap="$8"
              justifyContent="space-between"
              padding="$16"
            >
              <YStack>
                <Typography size="$sm" textAlign="left" variant="label">
                  {i18n.t('insights_hub.hidden_alerts.title')}
                </Typography>
                <Typography muted size="$xs">
                  {i18n.t('insights_hub.hidden_alerts_section')}
                </Typography>
              </YStack>

              <XStack alignItems="center" gap="$16">
                <Typography color="$textTertiary" size="$sm" variant="label">
                  {alerts.length}
                </Typography>
                <Icons.ChevronRight color="$iconPrimary" size="$16" />
              </XStack>
            </XStack>
          </AlertCardSurface>
        </YStack>
      </Pressable>

      <InsightsMobileHiddenAlertsPushView
        alerts={alerts}
        clearing={clearing}
        onAccountDetailPress={handleAccountDetailPress}
        onAlertPress={handleAlertPress}
        onClearAll={onClearAll}
        onClose={() => setOpen(false)}
        onDelete={onDelete}
        onRestore={onRestore}
        open={open}
      />
    </>
  );
};
